import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { type IFile } from "src/interfaces";
import { type IComment } from "src/pages/Summary/Summary.types";
import { ButtonsWrapper } from "src/styled";

import ExportEntryComments from "./ExportEntryComments";
import ExportEntryFiles from "./ExportEntryFiles";

interface Props {
  lbname: string | undefined;
  comments: IComment[] | undefined;
  files: IFile[] | undefined;
}

const ExportEntryHeader = ({ lbname, comments, files }: Props) => {
  const { pathname, search } = useLocation();

  const handleLinks = useCallback(() => {
    const links = [];
    links.push({ title: "Medical Log Entries", href: "/exports" + search });
    let entryTitle = "Entry";
    if (lbname) {
      entryTitle += ` - ${lbname}`;
    }
    links.push({ title: entryTitle, href: pathname + search });
    return links;
  }, [lbname, pathname, search]);

  return (
    <Breadcrumbs
      style={{ marginBottom: 20 }}
      border={false}
      customLinks={handleLinks}>
      <ButtonsWrapper>
        <ExportEntryComments comments={comments} />
        <ExportEntryFiles files={files} />
      </ButtonsWrapper>
    </Breadcrumbs>
  );
};

export default ExportEntryHeader;
